import qs from 'qs'

// Used to check whether an entry exists in another locale than the one being
// browsed. Only the title is needed for the notice, so none of the blocks,
// media or relations of `queryEventEntryBySlug` are requested.
export const queryEventEntryTitleBySlug = (options: QueryBySlugOptions) => {
  const query = qs.stringify(
    {
      publicationState: options.publicationState || 'live',
      locale: options?.locale || 'nl-NL',
      pagination: {
        limit: 1
      },
      filters: {
        slug: {
          $eq: options.slug
        }
      },
      fields: [
        'title',
        'slug',
        'locale'
      ]
    },
    {
      encodeValuesOnly: true
    }
  )

  return `event-entries?${query}`
}
